// ✅ Trekkin.app — panelRegistry.jsx v1.0.0 (COMPONENT MAP ISOLATED)
// -----------------------------------------------------------------
// ─ Evita ciclos diretos entre usePanelsStore e os componentes.
// ─ Expõe o mapeamento nome → componente que o PanelShell usa.
// -----------------------------------------------------------------
import { lazy } from "react";
import PanelNav from "./PanelNav.jsx";
import PanelResetPassword from "./PanelResetPassword.jsx";
import PanelLiveShare from "./PanelLiveShare.jsx";
import PanelLogin from "./PanelLogin.jsx";
import PanelGuide from "./PanelGuide.jsx";
import IntroScreen from "./IntroScreen.jsx";
import PanelBikeService from "./PanelBikeService.jsx";
import PanelBikeRental from "./PanelBikeRental.jsx";

const deferredPanel = (loader) => lazy(loader);
const PanelGuideDirectChats = deferredPanel(() => import("./PanelGuideDirectChats.jsx"));
const PanelGroupChat = deferredPanel(() => import("./PanelGroupChat.jsx"));
const PanelGroupManage = deferredPanel(() => import("./PanelGroupManage.jsx"));
const PanelGroupTrack = deferredPanel(() => import("./PanelGroupTrack.jsx"));
const PanelTrail = deferredPanel(() => import("./PanelTrail.jsx"));
const PanelTrailDetails = deferredPanel(() => import("./PanelTrailDetails.jsx"));
const PanelNavRealtime = deferredPanel(() => import("./PanelNavRealtime.jsx"));
const SettingsPanel = deferredPanel(() => import("./SettingsPanel.jsx"));
const PanelConfigurator = deferredPanel(() => import("./PanelConfigurator.jsx"));
const PanelHistory = deferredPanel(() => import("./PanelHistory.jsx"));
const PanelActivitySummary = deferredPanel(() => import("./PanelActivitySummary.jsx"));
const PanelAdmin = deferredPanel(() => import("./PanelAdmin.jsx"));
const PanelAdminCustomPush = deferredPanel(() => import("./PanelAdminCustomPush.jsx"));
const PanelAdminRtdbTraffic = deferredPanel(() => import("./PanelAdminRtdbTraffic.jsx"));
const PanelAdminGamification = deferredPanel(() => import("./PanelAdminGamification.jsx"));
const PanelAlertsAdmin = deferredPanel(() => import("./PanelAlertsAdmin.jsx"));
const PanelGlobalChat = deferredPanel(() => import("./PanelGlobalChat.jsx"));
const PanelDirectChat = deferredPanel(() => import("./PanelDirectChat.jsx"));
const PanelWaypointsAdmin = deferredPanel(() => import("./PanelWaypointsAdmin.jsx"));
const PanelWaypoints = deferredPanel(() => import("./PanelWaypoints.jsx"));
const PanelProfile = deferredPanel(() => import("./PanelProfile.jsx"));
const PanelAlertsCreate = deferredPanel(() => import("./PanelAlertsCreate.jsx"));
const PanelNavGridAdmin = deferredPanel(() => import("./PanelNavGridAdmin.jsx"));
const PanelSubscriptions = deferredPanel(() => import("./PanelSubscriptions.jsx"));
const PanelEventList = deferredPanel(() => import("./PanelEventList.jsx"));
const PanelEventDetails = deferredPanel(() => import("./PanelEventDetails.jsx"));
const PanelEventEnrollSuccess = deferredPanel(() => import("./PanelEventEnrollSuccess.jsx"));
const PanelEventManage = deferredPanel(() => import("./PanelEventManage.jsx"));
const PanelEventCreate = deferredPanel(() => import("./PanelEventCreate.jsx"));
const PanelEventEdit = deferredPanel(() => import("./PanelEventEdit.jsx"));
const PanelEventUploadReceipt = deferredPanel(() => import("./PanelEventUploadReceipt.jsx"));
const PanelEventRegister = deferredPanel(() => import("./PanelEventRegister.jsx"));
const PanelRolePermissions = deferredPanel(() => import("./PanelRolePermissions.jsx"));
const PanelAdminReports = deferredPanel(() => import("./PanelAdminReports.jsx"));
const PanelMapSelectPoint = deferredPanel(() => import("./PanelMapSelectPoint.jsx"));
const PanelSetNewPassword = deferredPanel(() => import("./PanelSetNewPassword.jsx"));
const PanelGamification = deferredPanel(() => import("./PanelGamification.jsx"));
const PanelAdminPublicGpx = deferredPanel(() => import("./PanelAdminPublicGpx.jsx"));
const PanelPublicTrails = deferredPanel(() => import("./PanelPublicTrails.jsx"));
const PanelAdminSalesVouchers = deferredPanel(() => import("./PanelAdminSalesVouchers.jsx"));
const PanelAdminGuideRatings = deferredPanel(() => import("./PanelAdminGuideRatings.jsx"));
const PanelIssueReport = deferredPanel(() => import("./PanelIssueReport.jsx"));
const PanelMyIssueReports = deferredPanel(() => import("./PanelMyIssueReports.jsx"));
const PanelPartnerReservations = deferredPanel(() => import("./PanelPartnerReservations.jsx"));
const PanelShareLocation = deferredPanel(() => import("./PanelShareLocation.jsx"));

export const PANEL_COMPONENTS = {
  intro: IntroScreen,
  login: PanelLogin,
  resetPassword: PanelResetPassword,
  nav: PanelNav,
  settings: SettingsPanel,
  setNewPassword: PanelSetNewPassword,
  navRealtime: PanelNavRealtime,
  trailDetails: PanelTrailDetails,
  trail: PanelTrail,
  groupChat: PanelGroupChat,
  groupManage: PanelGroupManage,
  groupTrack: PanelGroupTrack,
  globalChat: PanelGlobalChat,
  directChat: PanelDirectChat,
  guideDirectChats: PanelGuideDirectChats,
  guide: PanelGuide,
  history: PanelHistory,
  activitySummary: PanelActivitySummary,
  configurator: PanelConfigurator,
  admin: PanelAdmin,
  adminCustomPush: PanelAdminCustomPush,
  adminRtdbTraffic: PanelAdminRtdbTraffic,
  adminGamification: PanelAdminGamification,
  alertsAdmin: PanelAlertsAdmin,
  adminWaypoints: PanelWaypointsAdmin,
  waypoints: PanelWaypoints,
  profile: PanelProfile,
  liveShare: PanelLiveShare,
  shareLocation: PanelShareLocation,
  alertsCreate: PanelAlertsCreate,
  adminNavGrid: PanelNavGridAdmin,
  subscriptions: PanelSubscriptions,
  eventList: PanelEventList,
  eventDetails: PanelEventDetails,
  eventEnrollSuccess: PanelEventEnrollSuccess,
  eventManage: PanelEventManage,
  eventCreate: PanelEventCreate,
  eventEdit: PanelEventEdit,
  eventUploadReceipt: PanelEventUploadReceipt,
  eventRegister: PanelEventRegister,
  rolePermissions: PanelRolePermissions,
  adminReports: PanelAdminReports,
  mapSelectPoint: PanelMapSelectPoint,
  gamification: PanelGamification,
  adminPublicGpx: PanelAdminPublicGpx,
  publicTrails: PanelPublicTrails,
  adminSalesVouchers: PanelAdminSalesVouchers,
  adminGuideRatings: PanelAdminGuideRatings,
  issueReport: PanelIssueReport,
  myIssueReports: PanelMyIssueReports,
  partnerReservations: PanelPartnerReservations,
  bikeService: PanelBikeService,
  bikeRental: PanelBikeRental,
};

export const PANEL_FALLBACK = PanelResetPassword;
